import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { PasswordValidators } from '../../../../shared/components/validators/password.validators';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { MatButtonModule } from '@angular/material/button';
import { InputField } from '../../../../shared/components/input-field/input-field';
import { SystemUser, WebsiteExtended } from '../../../../shared/models/website-overview.model';

@Component({
  selector: 'app-add-ftp-user-dialog',
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    InputField,
  ],
  templateUrl: './add-ftp-user-dialog.component.html',
  styleUrl: './add-ftp-user-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddFtpUserDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<AddFtpUserDialogComponent>);

  readonly data = inject<
    DialogData & {
      website: WebsiteExtended;
      systemUser: SystemUser;
      server: string;
      domain: string;
    }
  >(MAT_DIALOG_DATA);

  private fb = inject(FormBuilder);

  form = this.fb.nonNullable.group({
    systemUserId: [0, [Validators.required]],
    websiteId: [0, [Validators.required]],
    server: ['', [Validators.required]],
    username: ['', [Validators.required, Validators.maxLength(15)]],
    password: [
      '',
      [
        PasswordValidators.required(),
        PasswordValidators.complexity(),
        PasswordValidators.allowedCharacters(),
        PasswordValidators.minLength(),
        PasswordValidators.maxLength(),
      ],
    ],
    homeDir: [''],
  });

  ngOnInit(): void {
    this.form.controls.websiteId.setValue(this.data.website.id);
    this.form.controls.systemUserId.setValue(this.data.systemUser.id);
    this.form.controls.server.setValue(this.data.server);

    const homeDir =
      this.data.website.type === 'MAIN'
        ? `${this.data.systemUser.homeDirectory}/public_html`
        : `${this.data.systemUser.homeDirectory}/domains/${this.data.domain}/public_html`;

    this.form.controls.homeDir.setValue(homeDir);
  }

  submit(): void {
    if (this.form.invalid) return;

    this.dialogRef.close(this.form.getRawValue());
  }

  close(): void {
    this.dialogRef.close();
  }
}
